import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// import { logger } from 'packages';
import STRINGS from 'constants/strings';
import {
    FilterCategories,
    FilterBrands,
    RadioButtonFilter,
    Accordion,
    AccordionItem,
    PriceRange,
    Spinner
} from 'components';
import RadioSwitchFilter from './radio-switch-filter';
import * as gtm from '../search-gtm';

const SearchFilter = ({
    filters,
    filterCategories,
    filterBrands = {},
    filterPrice = {},
    handleCategoryChange,
    handleFilterChange,
    handleBrandChange,
    handlePriceFilterChange,
    pageType,
    queryParams,
    isUpdating
}) => {
    const { options: brands } = filterBrands;
    const { itemCondition, sellerType, itemStatus, county, itemType } = filters;
    const { fromPrice = {}, toPrice = {} } = filterPrice;
    return (
        <Fragment>
            {isUpdating && <Spinner className="filters--updating" />}
            <Accordion title={'Filters'}>
                {!filterCategories || !filterCategories.categoryTree ? null : (
                    <AccordionItem
                        title={STRINGS.DISCOVER.FILTERS.ALL_CATEGORIES}
                        defaultOpen
                        collapsable={false}
                        hideTitle={true}
                        css={'d-none d-md-block pb-2 accordion--categories'}
                        render={() => (
                            <FilterCategories
                                filterCategories={filterCategories}
                                handleCategoryChange={handleCategoryChange}
                                pageType={pageType}
                                queryParams={queryParams}
                            />
                        )}
                    />
                )}
                <AccordionItem
                    title={STRINGS.DISCOVER.FILTERS.BRANDS}
                    onChange={() => gtm.trackAccordion('brandTags')}
                    defaultOpen
                    css={!brands || brands.length < 1 ? 'd-none' : 'd-block'}
                    render={() => (
                        <FilterBrands
                            filterBrands={filterBrands}
                            handleBrandChange={handleBrandChange}
                            queryParams={queryParams}
                            pageType={pageType}
                        />
                    )}
                />
                <AccordionItem
                    title={STRINGS.DISCOVER.FILTERS.CONDITION}
                    onChange={() => gtm.trackAccordion('itemCondition')}
                    defaultOpen
                    render={() => (
                        <RadioSwitchFilter
                            filter={itemCondition}
                            handleFilterChange={handleFilterChange}
                            id="filter-itemCondition"
                        />
                    )}
                />
                <AccordionItem
                    title={STRINGS.DISCOVER.FILTERS.ITEM_TYPE}
                    onChange={() => gtm.trackAccordion('itemType')}
                    defaultOpen
                    render={() => (
                        <RadioSwitchFilter
                            filter={itemType}
                            handleFilterChange={handleFilterChange}
                            id="filter-itemType"
                        />
                    )}
                />
                <AccordionItem
                    title={STRINGS.DISCOVER.FILTERS.PRICE}
                    onChange={() => gtm.trackAccordion('price')}
                    defaultOpen
                    render={() => (
                        <PriceRange
                            rangeStart={1}
                            rangeEnd={5000}
                            handleStart={fromPrice.value || 1}
                            handleEnd={toPrice.value || 5000}
                            handlePriceFilterChange={handlePriceFilterChange}
                        />
                    )}
                />
                <AccordionItem
                    title={STRINGS.DISCOVER.FILTERS.SELLER_TYPE}
                    onChange={() => gtm.trackAccordion('sellerType')}
                    defaultOpen
                    render={() => (
                        <RadioSwitchFilter
                            filter={sellerType}
                            handleFilterChange={handleFilterChange}
                            id="filter-sellerType"
                        />
                    )}
                />
                <AccordionItem
                    title={STRINGS.DISCOVER.FILTERS.COUNTY}
                    onChange={() => gtm.trackAccordion('countyBox')}
                    defaultOpen={false}
                    collapsable={true}
                    render={() => (
                        <RadioButtonFilter
                            filter={county}
                            handleFilterChange={handleFilterChange}
                            id="filter-countyBox"
                        />
                    )}
                />
                <AccordionItem
                    title={STRINGS.DISCOVER.FILTERS.ITEM_STATUS}
                    onChange={() => gtm.trackAccordion('itemStatus')}
                    defaultOpen={false}
                    render={() => (
                        <RadioSwitchFilter
                            filter={itemStatus}
                            handleFilterChange={handleFilterChange}
                            id="filter-itemStatus"
                        />
                    )}
                />
            </Accordion>
        </Fragment>
    );
};

SearchFilter.propTypes = {
    filters: PropTypes.object,
    filterCategories: PropTypes.object,
    filterBrands: PropTypes.object,
    filterPrice: PropTypes.object,
    handleCategoryChange: PropTypes.func,
    handleFilterChange: PropTypes.func,
    handleBrandChange: PropTypes.func,
    handlePriceFilterChange: PropTypes.func,
    pageType: PropTypes.string,
    queryParams: PropTypes.object,
    isUpdating: PropTypes.bool
};

export default SearchFilter;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/filters/search-filter.jsx